export default "__VITE_ASSET__D8N1MuQW__"